import { useParams } from "react-router-dom";
import { Button, Container, Divider, Image, Text, Title } from "@mantine/core";
import { useForm } from "react-hook-form";
import { PasswordInput } from "react-hook-form-mantine";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useGetUserByInviteToken, useSetPassword } from "../../api/auth";
import { useConfirm } from "../../hooks/useConfirm";
import Logo from "../../assets/logo-02.svg";
import LoadingPage from "../common/LoadingPage";
import { web_confirmPasswordSchema } from "@congrs/schemas";
import resolver from "@congrs/resolver";

function Register() {
  const token = useParams().token;

  const [disableForm, setDisableForm] = useState(false);

  const {
    data: userData,
    isSuccess,
    isError,
    isLoading,
  } = useGetUserByInviteToken(token);

  // Check if the token is expired or password is already set
  const notValid =
    userData?.status === "password set" || userData?.status === "token expired";

  const { mutate: setPassword, isSuccess: setPasswordSuccess } =
    useSetPassword();

  const errorMessage = isError
    ? "Invalid token."
    : userData?.status === "password set"
      ? "Password already set."
      : userData?.status === "token expired"
        ? "Token expired."
        : null;

  const confirm = useConfirm();

  useEffect(() => {
    if (isError || (isSuccess && notValid)) {
      setDisableForm(true);
    }
  }, [userData, isSuccess, isError]);

  const [successMessage, setSuccessMessage] = useState(null);

  useEffect(() => {
    if (setPasswordSuccess) {
      setSuccessMessage("Password set successfully!");
    }
  }, [setPasswordSuccess]);

  const { control, handleSubmit } = useForm({
    defaultValues: {
      password: "",
      confirmPassword: "",
    },
    resolver: resolver(web_confirmPasswordSchema, { $data: true }),
  });

  const onSubmit = (data) => {
    confirm({
      title: "Save password?",
      message: "Please confirm to proceed.",
      onConfirm: () => setPassword({ token, password: data.password }),
    });
  };

  if (isLoading) {
    return <LoadingPage />;
  }
  return (
    <Container size={420}>
      <Image src={Logo} alt="congrs logo" />
      <Title>Registration</Title>
      <Text>
        Please finish sign up with your social account or set your password to
        register.
      </Text>
      <form onSubmit={handleSubmit((data) => onSubmit(data))}>
        <PasswordInput
          label="Set Password"
          placeholder="Enter your password"
          name="password"
          control={control}
          withAsterisk
          mt="md"
          disabled={disableForm}
        />
        <PasswordInput
          label="Confirm Password"
          placeholder="Confirm your password"
          name="confirmPassword"
          control={control}
          withAsterisk
          mt="md"
          disabled={disableForm}
        />
        <Button
          type="submit"
          variant="gradient"
          fullWidth
          size="md"
          my={10}
          disabled={disableForm}
        >
          Register
        </Button>

        {disableForm && setPasswordSuccess && (
          <>
            <Text c="green" ta="center">
              {successMessage}
            </Text>
            <Text ta="center" mb="md">
              Go to{" "}
              <Link to="/">
                <Text component="span" c="#243846" style={{ fontWeight: 700 }}>
                  web login page
                </Text>
              </Link>
            </Text>

            <Divider label="or" labelPosition="center" />

            <a href="/api/download" style={{ textDecoration: "none" }}>
              <Button
                variant="gradient"
                size="md"
                style={{
                  display: "inline-block",
                  marginTop: "10px",
                  width: "100%",
                  marginBottom: "40px",
                }}
              >
                Go to the mobile app
              </Button>
            </a>
          </>
        )}

        {disableForm && !setPasswordSuccess && (
          <Text c="red" ta="center" style={{ marginBottom: "40px" }}>
            {errorMessage}
          </Text>
        )}
      </form>
    </Container>
  );
}

export default Register;
